<h1 class="uk-h1 uk-text-center">Mes gares</h1>

<div class="uk-grid uk-padding-small">
  <div class="uk-width-1-1 uk-flex uk-flex-center">
    <button matButton="filled" (click)="editBusStation()">Ajouter</button>
  </div>
</div>

@if (busStations && busStations.length > 0) {
  <table mat-table [dataSource]="tableSource" matSort class="mat-elevation-z8 uk-width-1-1">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
      <td mat-cell *matCellDef="let element"> {{ element.name || "Non défini" }}</td>
    </ng-container>
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ville</th>
      <td mat-cell *matCellDef="let element"> {{ cityStoreService.getById(element.cityId)?.name || 'Non défini' }}</td>
    </ng-container>
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let element"><i class="material-icons clickable" style="cursor: pointer"
                                                matTooltip="Modifier"
                                                (click)="editBusStation(element.id)">edit</i></td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let element"><i class="material-icons clickable" style="cursor: pointer"
                                                matTooltip="Supprimer"
                                                (click)="removeBusStations(element.id)">delete</i></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
  </table>
} @else {
  <div class="uk-alert uk-alert-warning uk-text-center">Vous n'avez créer aucune gare</div>
}
